import { Injectable } from "@angular/core";
import { HttpClient } from "../../common/HttpClient";
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";




@Injectable()
export class StpConfigureService {

    constructor(private _http: HttpClient) {
    }

    public saveConnectorConfiguration(data): Observable<any> {
        return this._http.post(`${environment.serviceUrl}postConnectorConfigurationData`, {id : data._id, data : data});
    }

    public saveConnectorVariantConfiguration(data): Observable<any> {
        return this._http.post(`${environment.serviceUrl}postConnectorVariantConfigurationData`, {id : data._id, data : data});
    }
    public addNewPartListConnectorIntoDb(element): Observable<any> {
        return this._http.post(`${environment.serviceUrl}AddNewPartListConnector`, { element })
        .map(res => res.json());
    }
    public removePartListConnector(id): Observable<any> {
        return this._http.get(`${environment.serviceUrl}RemovePartListConnector`, '?id=' + id)
        .map(res => console.log(res));
    }
    public loadAllPartListConnectors(id): Observable<any> {
        return this._http.get(`${environment.serviceUrl}LoadAllPartListConnectors`, '?id=' + id)
        .map(res => res.json());
    }
    public updatePartListConnector(element): Observable<any> {
        return this._http.post(`${environment.serviceUrl}UpdatePartListConnector`, { element })
        .map(res => res.json());
    }
}
